import PropTypes from "prop-types";
import * as React from "react";
import { translate } from "react-i18next";
import moment from "moment";
import { roleNames } from "roles";
import styles from "./ClanLeaveDialog.scss";
import { isoToFormattedLocalDate, isoToFormattedLocalTime } from "helpers/datetime";
import settings from "settings";

import { DialogContainer, DialogHeader, DialogBody, DialogFooter, Button, ButtonGroup, Divider, MemberName, Message } from "@wg/wows-react-uikit";

import { MemberSelect } from "../UIKit";

const propTypes = {
  members: PropTypes.array.isRequired,
  newCommander: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    roleName: PropTypes.oneOf(roleNames).isRequired
  }),

  isFetching: PropTypes.bool,

  onChangeCommander: PropTypes.func,
  onSelectCommander: PropTypes.func,
  onLeaveClanSubmit: PropTypes.func,
  onDisbandClan: PropTypes.func,
  onHideDialog: PropTypes.func,

  t: PropTypes.func.isRequired
};

class ClanLeaveDialog extends React.Component {

  constructor(props) {
    super(props);

    this.dialogType = null;
    if (this.props.members.length === 0) {
      this.dialogType = 'disband';
    } else if (this.props.newCommander && this.props.members.length > 1) {
      this.dialogType = 'selectCommander';
    } else if (this.props.newCommander && this.props.members.length === 1) {
      this.dialogType = 'commanderWasSelected';
    }
    this.state = {
      members: this.props.members,
      newCommander: this.props.newCommander
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {// eslint-disable-line
    if (nextProps.newCommander && this.props.newCommander !== nextProps.newCommander) {
      this.setState({
        newCommander: nextProps.newCommander
      });
    }
  }

  getAction() {
    let onActionClick = this.props.onLeaveClanSubmit;
    const {
      newCommander
    } = this.state;

    if (this.dialogType === 'disband') {
      onActionClick = this.props.onDisbandClan;
    } else if (this.dialogType === 'selectCommander') {
      onActionClick = this.props.onChangeCommander.bind(this, newCommander.id);
    } else if (this.dialogType === 'commanderWasSelected') {
      onActionClick = this.props.onChangeCommander.bind(this, newCommander.id);
    }
    return onActionClick;
  }

  renderBodyContent() {
    const t = this.props.t;
    const {
      newCommander,
      members
    } = this.state;
    let bodyContent = null;
    if (this.dialogType === 'disband') {
      bodyContent = <div className={styles.container}>
                    <div className={styles.inner}>
                        <div className={styles.message}>{t('После вашего ухода клан будет распущен')}</div>
                    </div>
                    <Divider type="major" />
                </div>;
    } else if (this.dialogType === 'selectCommander') {
      bodyContent = <div className={styles.container}>
                    <div className={styles.inner}>
                        <div className={styles.message}>{t('Новый командующий флотом')}</div>
                        <MemberSelect members={members} selected={newCommander.id} onChange={this.props.onSelectCommander} />
                    </div>
                    <Divider type="major" />
                </div>;
    } else if (this.dialogType === 'commanderWasSelected') {
      bodyContent = <div className={styles.container}>
                    <div className={styles.inner}>
                        <div className={styles.message}>{t('Новый командующий флотом')}</div>
                        <MemberName role={newCommander.roleName} name={newCommander.name} />
                    </div>
                    <Divider type="major" />
                </div>;
    }
    return bodyContent;
  }

  renderConfirmationMessage() {
    const t = this.props.t;
    const cooldown = settings.clanLeaveCooldown;
    if (!cooldown) return null;

    const cooldownEnd = moment().add(cooldown, 'days');

    // Ugly hack because wscp can't work with plurals yet
    const l10n = cooldown === 3 ? t('После ухода из клана в течение 3 дней вы не сможете вступить в клан или создать новый.') : t('После ухода из клана вы сможете вступить в клан или создать новый начиная с %(date)s&nbsp;%(time)s.', {
      date: isoToFormattedLocalDate(cooldownEnd),
      time: isoToFormattedLocalTime(cooldownEnd)
    }).replace('&nbsp;', '\u00a0');

    return <div className={styles.confirmation}>{l10n}</div>;
  }

  render() {
    const t = this.props.t;

    const buttonActionText = this.dialogType === 'disband' ? t('Распустить клан') : t('Покинуть клан');
    const onActionClick = this.getAction();

    return <DialogContainer>
                <DialogHeader>{t('Покинуть клан')}</DialogHeader>
                <DialogBody>
                    {this.renderBodyContent()}
                    <div className={styles.confirmation}>{t('Вы уверены, что хотите покинуть клан?')}</div>
                    <Divider type="major" />
                    <div className={styles.info}>
                        <Message type="error">{t('Заработанные в этом клане баррели нефти обнуляются. В новом клане вы начнёте зарабатывать их заново.')}</Message>
                    </div>
                    {this.renderConfirmationMessage()}
                </DialogBody>
                <DialogFooter>
                    <ButtonGroup isLoading={this.props.isFetching}>
                        <Button isJustified isHighlighted onClick={onActionClick}>
                            {buttonActionText}
                        </Button>
                        <Button isJustified onClick={this.props.onHideDialog}>
                            {t('Отмена')}
                        </Button>
                    </ButtonGroup>
                </DialogFooter>
            </DialogContainer>;
  }
}

ClanLeaveDialog.propTypes = propTypes;

export default translate()(ClanLeaveDialog);